// extracted by css-extract-rspack-plugin
export default {"description":"description-CKQUPy","last-status":"last-status-js4NpE","lastStatus":"last-status-js4NpE"};